import { render } from "./InactiveScreen.vue?vue&type=template&id=ea74f95a&scoped=true"
import script from "./InactiveScreen.vue?vue&type=script&lang=js"
export * from "./InactiveScreen.vue?vue&type=script&lang=js"

import "./InactiveScreen.vue?vue&type=style&index=0&id=ea74f95a&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_aethon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea74f95a"]])

export default __exports__